import { bossWebAxios } from '../api';
import { moduleNameMap } from '../config';

const { TW_MERCHANT_BOSS } = moduleNameMap;
const boss = `${TW_MERCHANT_BOSS}/boss`;

// 修改门店营业状态
export const updateStoreStatus = (params, config) => bossWebAxios(params, `${boss}/update-store-status`, config)

export const getStoreList = (params, config) => bossWebAxios(params, `${boss}/get-merchant-store`, config)
/**
 * 门店信息
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const getStoreInfo = (params, config) => bossWebAxios(params, `${boss}/get-store-info`, config);
/**
 * 门店信息修改
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const updateStoreInfo = (params, config) => bossWebAxios(params, `${boss}/update-store-info`, config);

/**
 * 营业信息
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const getStoreBusiness = (params, config) => bossWebAxios(params, `${boss}/get-store-business`, config);
/**
 * 营业信息修改
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const upadteStoreBusiness = (params, config) => bossWebAxios(params, `${boss}/update-store-business`, config);
/**
 * 门店开业
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const startBusiness = (params, config) => bossWebAxios(params, `${boss}/start-business`, config);
/**
 * 财务信息
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const getStoreBilling = (params, config) => bossWebAxios(params, `${boss}/get-store-billing`, config);
/**
 * 图片信息
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const getStorePicture = (params, config) => bossWebAxios(params, `${boss}/get-store-picture`, config);

export const getScopeCode = (params, config) => bossWebAxios(params, `${boss}/classification-store-operation/listNoCount`, config)

/**
 * 根据操作员编号获取商户信息
 * @param params
 * @param config
 */
export const getAccountInfoByOperateNo = (params, config) => bossWebAxios(params, `operator/info/get.do`, config)

export const getAcountInfoByStoreNo = (params, config) => bossWebAxios(params, `${boss}/get-account-manager`, config)


// 运营配置活动根据key值获取
export const systemConfigGetByKey = (params, config)  => bossWebAxios(params, `${boss}/getByKey`,config)